import { generateGUID } from "../../../utils/guid.js";
import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/notification/thunks/show-notification.ts
var showNotification = createAsyncThunk(thunkTypes.SHOW_NOTIFICATION, async (param, { dispatch }) => {
	const notification = {
		id: generateGUID(),
		type: param.type,
		text: param.text,
		icon: param.icon
	};
	dispatch(actions.show(notification));
	return notification;
});
//#endregion
export { showNotification };

//# sourceMappingURL=show-notification.js.map